import markerRecord from "./marker-record";
import {appContainer} from "../contexts/app";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate} from "./hooks";

export default app => {
  const service = app.service("api/markers");

  const MarkerRecord = markerRecord(service, appContainer.InfographicRecord);

  const validateMarker = validate({
    name: "Marker name is required.",
    type_id: "Marker type is required."
  });

  appContainer.MarkerRecord = MarkerRecord;
  app.set("MarkerRecord", MarkerRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateMarker],
      update: [fromImmutable, validateMarker],
      patch: [fromImmutable, validateMarker],
      remove: []
    },

    after: {
      all: [toImmutable(MarkerRecord)],
      find: [setListInState("markers")],
      get: [setInState("markers")],
      create: [setInState("markers")],
      update: [setInState("markers")],
      patch: [setInState("markers")],
      remove: [deleteInState("markers")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/markers-setup.js